<div class="detail-page-card">
    <div class="detail-page-card-title">{{ 'info.detailsTitle' | t }}</div>
    <div class="detail-page-card-body padded cerrix-control-sm form-group-styling">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label>{{ 'info.firstNameLabel' | t }}</label>
                    <cerrix-textfield
                        dataUiid="userinfo-firstname"
                        [(ngModel)]="user.firstname"
                        [disabled]="!permissions.canEditDetails"
                        [required]="true"
                    >
                    </cerrix-textfield>
                </div>
                <div class="form-group">
                    <label>{{ 'info.lastNameLabel' | t }}</label>
                    <cerrix-textfield
                        dataUiid="userinfo-lastname"
                        [(ngModel)]="user.lastname"
                        [disabled]="!permissions.canEditDetails"
                        [required]="true"
                    >
                    </cerrix-textfield>
                </div>
                <div class="form-group">
                    <label
                        >{{ 'info.emailLabel' | t }}
                        <i
                            class="fas fa-info-circle ms-2"
                            position="right"
                            [matTooltip]="'info.emailTooltip' | t"
                        ></i>
                    </label>
                    <cerrix-textfield
                        dataUiid="userinfo-email"
                        type="email"
                        [(ngModel)]="user.email"
                        [disabled]="!permissions.canEditDetails"
                        [placeholder]="'info.emailPlaceholder' | t"
                    >
                    </cerrix-textfield>
                </div>
                <div class="form-group">
                    <label>{{ 'info.organizationLabel' | t }}</label>
                    @if (sd.organizations) {
                        <cerrix-select-tree
                            data-uiid="userinfo-organization"
                            [tree]="sd.organizations"
                            [multiselect]="false"
                            [readonly]="!permissions.canEditDetails"
                            [value]="user.organization"
                            (onChangeSingleId)="user.organization = $event"
                        ></cerrix-select-tree>
                    }
                </div>
                <div class="form-group">
                    <label for="userinfo-language">{{ 'info.languageLabel' | t }}</label>
                    <cerrix-select
                        id="userinfo-language"
                        dataUiid="userinfo-language"
                        [getDataMethod]="languageOptions"
                        [(ngModel)]="languageSelectValue"
                        [disabled]="!permissions.canEditDetails"
                        [clearable]="false"
                        bindLabel="Name"
                        bindValue="ID"
                    ></cerrix-select>
                </div>
            </div>
            <div class="col-6 d-flex flex-column">
                <div class="form-group remarks-group">
                    <label>{{ 'info.remarksLabel' | t }}</label>
                    <cerrix-textarea
                        dataUiid="userinfo-remarks"
                        [(ngModel)]="user.remarks"
                        [disabled]="!permissions.canEditDetails"
                    ></cerrix-textarea>
                </div>
            </div>
        </div>
    </div>
</div>
